export default {
  remote: 'translations_tool_simplify',
  name: 'translations-tool',
  source: 'https://github.com/telus/translations-tool-simplify',
  urlMapping: {
    localhost: 'http://localhost:4321/mf-manifest.json',
    'simplify.developers.telus.digital':
      'https://assets.wcpreview.telus.com/1090435990/translations-tool-simplify/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital':
      'https://assets.wcstage.telus.com/1090435990/translations-tool-simplify/v1/mf2/mf-manifest.json',
    'simplify.telus.com':
      'https://assets.telus.com/1090435990/translations-tool-simplify/v1/mf2/mf-manifest.json',
  },
};
